import TicketListView from "@/views/admin/tickets/TicketListView";
import TicketDetailView from "@/views/admin/tickets/TicketDetailView";

const meta = { middleware: ["auth"], roles: ["admin", "super_admin"] };

export default [
    {
        name: "admin.tickets",
        path: "tickets",
        component: TicketListView,
        meta,
    },
    {
        name: "admin.tickets.show",
        path: "tickets/:id",
        component: TicketDetailView,
        meta,
    },
];
